import { Box, Stack, Typography } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { useFormikContext } from "formik";
import { Attachment } from "../attachments/helpers.js";
import { AllowedValueLabelWithOverride } from "./AllowedValueLabelWithOverride.js";
import { ValueMediaBool } from "./form-fields/PropertyValuesMediaBoolField.js";
import { PropType } from "./properties.js";

export interface AllowedValuesMediaFormWithOverrideFormValues {
  allowedValuesMedia: { valueAsString: string; media: Attachment | null }[];
}

interface Props {
  propValuesMediaBool: ValueMediaBool[];
  propertyType: PropType;
}

export const AllowedValuesMediaFormWithOverride = ({
  propValuesMediaBool,
  propertyType,
}: Props) => {
  const { t } = useTranslate(["QuoteItem"]);
  const formikProps =
    useFormikContext<AllowedValuesMediaFormWithOverrideFormValues>();

  const onAllowedValueMediaChange = async (
    valueAsString: string,
    media: Attachment | null | undefined
  ) => {
    let newValue = formikProps.values.allowedValuesMedia.filter(
      v => v.valueAsString !== valueAsString
    );
    if (media !== undefined) {
      newValue = [...newValue, { valueAsString, media }];
    }
    await formikProps.setFieldValue("allowedValuesMedia", newValue);
  };

  if (propertyType !== "BOOLEAN" || !propValuesMediaBool.length) return null;

  return (
    <Box>
      <Typography variant="body2" color="text.secondary">
        {t("Values", { ns: "QuoteItem" })}
      </Typography>
      <Stack direction="column" spacing={1}>
        {propValuesMediaBool.map(propAllowedValue => {
          const valueAsString =
            propAllowedValue.value !== null
              ? propAllowedValue.value.toString()
              : "null";
          const overriddenMedia = formikProps.values.allowedValuesMedia?.find(
            avm => avm.valueAsString === valueAsString
          )?.media;
          return (
            <AllowedValueLabelWithOverride
              key={`prop-value-media-bool-${valueAsString}`}
              overriddenMedia={overriddenMedia}
              valueAsString={valueAsString}
              onValueMediaChange={onAllowedValueMediaChange}
              propertyType={propertyType}
              media={propAllowedValue.media}
              value={propAllowedValue.value}
            />
          );
        })}
      </Stack>
    </Box>
  );
};
